import { useState, useEffect } from "react"
import { useParams, useHistory, useLocation } from "react-router-dom";
import { Card, CardBody, CardHeader, CardTitle, CardText, ListGroup, ListGroupItem, Row, Col, Button, Input, Label } from "reactstrap";
import Moment from "react-moment";
import PanelHeader from "components/PanelHeader/PanelHeader";
import HeaderInfoItem from "../Shared/HeaderInfoItem";
import HeaderAddress from "../Shared/HeaderAddress";
import CallService from "core/api/CallService"
import CustomerService from "core/api/CustomerService"
import BuildingService from "core/api/BuildingService"


const View = () => {
    const { id } = useParams();
    const [reportData, setReportData] = useState();
    const [loading, setLoading] = useState(true);
    const [buildingData, setBuildingData] = useState({
        id: "",
        customerId: "",
        name: "",
        company: "",
        line1: "",
        line2: "",
        city: "",
        state: "NY",
        postalCode: "",
        country: "USA",
        phone: "",
        email: "",
    });

    const [customerData, setCustomerData] = useState({
        name: "",
        company: "",
        line1: "",
        line2: "",
        city: "",
        state: "NY",
        postalCode: "",
        country: "USA",
        phone: "",
        email: "",
    });
    const [defaultContact, setDefaultContact] = useState()

    const history = useHistory();

    const ReviewCall = async () => {
        const results = await CallService.update({ ...reportData, status: "reviewed" })
        setReportData(results)
    }

    useEffect(() => {
        async function fetchData() {
            const callData = await CallService.getWithRecording(id);
            const buildingInfo = await BuildingService.get(callData.buildingId);
            const customerInfo = await CustomerService.get(callData.customerId);

            setReportData(callData);
            setBuildingData(buildingInfo);
            setCustomerData(customerInfo);
            setDefaultContact(buildingInfo?.contacts?.find(contact => contact.defaultContact))
            setLoading(false);
        }
        fetchData();
    }, [])

    if (loading) return <>Loading</>;

    const isServiceRequest = reportData.callType === "CustomerService"

    return (
        <>
            <PanelHeader
                content={
                    <div className="header text-center">
                        <h1 className="title">
                            {isServiceRequest ? "Service Request Report" : "Elevator Report"}
                        </h1>
                        <h2 className="title">
                            {isServiceRequest
                                ? reportData.elevatorCompanyName
                                : reportData.elevatorName ?? "Unknown Elevator"}
                        </h2>
                    </div>
                }
            />
            <div className="content">
                <Row>
                    <Col xs={12} md={12}>
                        <Card>
                            <CardBody>
                                <Row>
                                    <Col style={{ border: "1px" }}>
                                        <HeaderInfoItem title="Customer">
                                            {customerData?.company ?? "Unknown"}
                                        </HeaderInfoItem>
                                        <HeaderInfoItem title="Contact Name">
                                            {customerData?.name}
                                        </HeaderInfoItem>
                                    </Col>
                                    <Col>
                                        <HeaderInfoItem title="Building">
                                            {buildingData?.buildingName ?? "Unknown"}
                                        </HeaderInfoItem>
                                        <HeaderInfoItem title="Building Contact Name">
                                            {defaultContact?.contactName}
                                        </HeaderInfoItem>
                                    </Col>

                                    <Col>
                                        <HeaderInfoItem title="Phone Number">
                                            {defaultContact?.phone}
                                        </HeaderInfoItem>
                                        <HeaderInfoItem title="Email Address">
                                            {defaultContact?.email}
                                        </HeaderInfoItem>
                                    </Col>
                                    {buildingData &&
                                    <Col>
                                        <HeaderAddress {...buildingData} />
                                    </Col>
                                    }
                                </Row>
                            </CardBody>
                        </Card>
                        <Card>
                            <CardHeader>
                                <CardTitle tag="h4">Call Information</CardTitle>
                                {/* Once set up user roles - Only show if user is admin */}
                                {reportData.status == "submitted" || reportData.status == "terminated" ? <Button color="primary" onClick={() => ReviewCall()} style={{ fontSize: 14 }} >Mark as Reviewed</Button> : <></>}
                            </CardHeader>
                            <CardBody>
                                <ListGroup >
                                    <ListGroupItem>
                                        <strong>Call Type:</strong> {isServiceRequest ? "Customer Service" : "Emergency"}
                                    </ListGroupItem>
                                    {isServiceRequest &&
                                        <ListGroupItem>
                                            <strong>Elevator Company:</strong> {reportData.elevatorCompanyName}
                                        </ListGroupItem>
                                    }
                                    <ListGroupItem>
                                        <strong>Ref:</strong> {reportData.userEmail}
                                    </ListGroupItem>
                                    <ListGroupItem>
                                        <strong>Elevator:</strong> {reportData.elevatorName ?? "Unknown"}
                                    </ListGroupItem>
                                    <ListGroupItem>
                                        <strong>{isServiceRequest ? "Caller ID:" : "Elevator Phone Number:"}</strong> {reportData.elevatorPhoneNumber}
                                    </ListGroupItem>
                                    <ListGroupItem>
                                        <strong>Building:</strong> {reportData.buildingName ?? "Unknown"}
                                    </ListGroupItem>
                                    {reportData.buildingAddress &&
                                        <ListGroupItem>
                                            <strong>Building Address:</strong> {reportData.buildingAddress}
                                        </ListGroupItem>
                                    }
                                    <ListGroupItem>
                                        <strong>Customer:</strong> {reportData.customerName ?? "Unknown"}
                                    </ListGroupItem>
                                    <ListGroupItem>
                                        <strong>Date Received:</strong> {reportData.dateTimeReceived != "0001-01-01T00:00:00Z" && <Moment>{reportData.dateTimeReceived}</Moment>}
                                    </ListGroupItem>
                                    <ListGroupItem>
                                        <strong>Date Answered:</strong> {reportData.dateTimeAnswered != "0001-01-01T00:00:00Z" && <Moment>{reportData.dateTimeAnswered}</Moment>}
                                    </ListGroupItem>
                                    <ListGroupItem>
                                        <strong>Date Submitted:</strong> {reportData.dateTimeSubmitted != "0001-01-01T00:00:00Z" && <Moment>{reportData.dateTimeSubmitted}</Moment>}
                                    </ListGroupItem>
                                    <ListGroupItem>
                                        <strong>Call Length:</strong> {reportData.callLength} {reportData.callLength == 1 ? "minute" : "minutes"}
                                    </ListGroupItem>
                                    <ListGroupItem>
                                        <strong>Status:</strong> {reportData.status.toUpperCase()}
                                    </ListGroupItem>
                                    {
                                        reportData.resolution != null &&
                                        <ListGroupItem>
                                            <strong>Resolution:</strong> {reportData.resolution}
                                        </ListGroupItem>
                                    }
                                    {
                                        reportData.status == "terminated" &&
                                        <ListGroupItem>
                                            <strong>Termination Reason:</strong> {reportData.surveyResults.terminationReason}
                                        </ListGroupItem>
                                    }
                                    {reportData.recordingUrl != null &&
                                        <ListGroupItem>
                                            <strong>Recording:</strong> <a href={reportData.recordingUrl} target='_blank'>{reportData.recordingUrl}</a>
                                        </ListGroupItem>
                                    }


                                </ListGroup>
                            </CardBody>
                        </Card>
                        <Card>
                            <CardHeader>
                                <CardTitle tag="h5">Call Questions</CardTitle>
                                <Button onClick={() => { history.push(`../call/${id}`, { showBackButton: true }) }}>View Report</Button> 
                            </CardHeader>

                            <CardBody>
                                <ListGroup flush={false}>
                                    {Object.keys(reportData.surveyResults).filter(key => key != "dispatchQuestions" && key != "buildingId").map((key, i) => (
                                        <ListGroupItem key={i}>
                                            <strong>{key.split(/(?=[A-Z])|(?=[0-9])/).map(part => part.charAt(0).toUpperCase() + part.slice(1)).join(' ')}: </strong> {reportData.surveyResults[key]}
                                        </ListGroupItem>
                                    ))}
                                </ListGroup>
                            </CardBody>
                        </Card>

                        {reportData?.dispatchInfo &&
                            <Card>
                                <CardHeader>
                                    <CardTitle tag="h4">SMS Dispatch Information</CardTitle>
                                </CardHeader>
                                <CardBody>
                                    <ListGroup >
                                        <ListGroupItem>
                                            <strong>SMS Sent:</strong>  {reportData.dispatchInfo.dateTimeSent != "0001-01-01T00:00:00Z" && <Moment>{reportData.dispatchInfo.dateTimeSent}</Moment>}
                                        </ListGroupItem>

                                        {reportData.dispatchInfo.response === "TimedOut" &&
                                            <ListGroupItem>
                                                <strong>Timed Out At:</strong> {reportData.dispatchInfo.timeoutAt != "0001-01-01T00:00:00Z" && <Moment>{reportData.dispatchInfo.timeoutAt}</Moment>}
                                            </ListGroupItem>
                                        }

                                        {reportData.dispatchInfo.response && reportData.dispatchInfo.response !== "TimedOut" &&
                                            <>
                                                <ListGroupItem>
                                                    <strong>Contact:</strong> {reportData.dispatchInfo.contactName} ({reportData.dispatchInfo.contactPhone})
                                                </ListGroupItem>
                                                <ListGroupItem>
                                                    <strong>Contact Response:</strong> {
                                                        reportData.dispatchInfo.response === "Requested911" ? "Requested 911 Dispatch" :
                                                            reportData.dispatchInfo.response === "CompanyDispatching" ? "Company Dispatching" :
                                                                reportData.dispatchInfo.response
                                                    }
                                                </ListGroupItem>
                                                <ListGroupItem>
                                                    <strong>Responded At:</strong> <Moment>{reportData.dispatchInfo.dateTimeResponded}</Moment>
                                                </ListGroupItem>
                                            </>
                                        }

                                        <ListGroupItem>
                                            <strong>Status:</strong> {
                                                reportData.dispatchInfo.status === "Pending" ? "Pending" :
                                                    reportData.dispatchInfo.status === "CompanyDispatching" ? "Company Dispatching" :
                                                        reportData.dispatchInfo.status === "Requested911" ? "911 Dispatch Requested" :
                                                            reportData.dispatchInfo.status === "TimedOut" ? "Timed Out" :
                                                                reportData.dispatchInfo.status === "Dispatched911" ? "911 Dispatched" :
                                                                    reportData.dispatchInfo.status === "DispatchNotNeeded" ? "Dispatch Not Needed" :
                                                                        reportData.dispatchInfo.status
                                            }
                                        </ListGroupItem>

                                        {reportData.dispatchInfo.status === "Dispatched911" &&
                                            <>
                                                <ListGroupItem>
                                                    <strong>Dispatched By:</strong> {reportData.dispatchInfo.dispatchedBy}
                                                </ListGroupItem>
                                                <ListGroupItem>
                                                    <strong>Dispatched At:</strong> {reportData.dispatchInfo.dateTime911Dispatched != "0001-01-01T00:00:00Z" && <Moment>{reportData.dispatchInfo.dateTime911Dispatched}</Moment>}
                                                </ListGroupItem>
                                                <ListGroupItem>
                                                    <strong>911 Confirmation:</strong> {reportData.dispatchInfo.confirmation911 ? "Yes" : "No"}
                                                </ListGroupItem>
                                            </>
                                        }

                                        {reportData.dispatchInfo.notes &&
                                            <ListGroupItem>
                                                <strong>Notes:</strong> {reportData.dispatchInfo.notes}
                                            </ListGroupItem>
                                        }

                                    </ListGroup>
                                </CardBody>
                            </Card>
                        }
                    </Col>
                </Row>
            </div >

        </>
    )
}

export default View